import React from "react";
import YouTube from "react-youtube-embed";
import ReadMore from "../Event/ReadMore";
import Footer from "../Footer";
import NavBar from "../NavBar";
import "./Achatwithchess.css";
const Achatwithchess = () => {
  return (
    <div>
      <NavBar />
      <section className="container mt-5">
        <div className="members__box__wrap">
          <div className="row">
            <h3 className="card__outerHeading">
              A Chat With <span className="text_primary">ChESS</span>: Placement Talk Sessions
            </h3>
            <hr className="hr" width="40%" style={{ margin: "1% auto" }} />
            <p className="lead card__lead">
              A new series launched by ChESS on its official YouTube channel
              based on Campus Placements experience of the Alumni of Chemical
              Engineering Depatment.
            </p>
            <div className="members__box__wrap outer">
              <div className="row mt-3">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card members__box">
                    <YouTube id="eR20TAr0REs" />
                    <div className="card-body">
                      <h4 className="card-title">
                        Reliance Industries Limited (Design Engineer), Campus
                        Placement Talk with Mr. TT Sriram (Nov 28, 2022)
                      </h4>
                      <hr />
                      <p className="card-text">
                        <ReadMore>
                          This time, we have with us Mr. TT Sriram, Founding
                          President of ChESS and Alumnus of the Chemical
                          Engineering Department, NIT Durgapur (2020 Batch),
                          currently working as a Design Engineer at Reliance
                          Industries Limited. Watch the video to get all your
                          doubts and queries regarding campus placement
                          opportunities in Reliance Industries Limited, and
                          other core companies, answered. Like, share and
                          subscribe to stay tuned for more such content. Do not
                          forget to hit the Bell Icon.
                        </ReadMore>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card members__box">
                    <YouTube id="WejkQaNVZ24" />
                    <div className="card-body">
                      <h4 className="card-title">
                        Vesuvius India Limited, Campus Placement Talk with Ms.
                        Kritika Raman (Nov 8, 2022)
                      </h4>
                      <hr />
                      <p className="card-text">
                        <ReadMore>
                          For the month of November, we have with us Ms. Kritika
                          Raman, Alumnus of Chemical Engineering Department, NIT
                          Durgapur (2022 Batch), currently working as a Graduate
                          Engineer Trainee (GET) in the Vesuvius India Limited.
                          Watch the video to get all your doubts and queries
                          regarding campus placement opportunities in Vesuvius
                          India Limited, and other core companies, answered.
                          Like, share and subscribe to stay tuned for more such
                          content. Do not forget to hit the Bell Icon.
                        </ReadMore>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card members__box">
                    {/* <img className="card-img-top background__img" src={""} alt="Event poster" /> */}
                    <YouTube id="7DX0HTPV3Sc" />
                    <div className="card-body">
                      <h4 className="card-title">
                        Reliance Industries Limited (STF), Campus Placement Talk
                        with Mr. Souvik Ghosh (Oct. 9, 2022)
                      </h4>
                      <hr />
                      <p className="card-text">
                        <ReadMore>
                          For the month of October, we have with us Mr. Souvik
                          Ghosh, Alumnus of Chemical Engineering Department, NIT
                          Durgapur (2022 Batch), currently working as a Graduate
                          Engineer Trainee (GET) in the Special Task Force
                          Division at Reliance Industries Limited. Watch the
                          video to get all your doubts and queries regarding
                          campus placement opportunities in Reliance Industries
                          Limited, and other core companies, answered.
                        </ReadMore>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card members__box">
                    {/* <img className="card-img-top background__img" src={""} alt="Event poster" /> */}
                    <YouTube id="RSJ4Ymx45Uc" />
                    <div className="card-body">
                      <h4 className="card-title">
                        Placement Talk with Mr. Amar Kumar Pandey, L&T
                        Energy-Hydrocarbon (Sept. 18, 2022)
                      </h4>
                      <hr />
                      <p className="card-text">
                        <ReadMore>
                          For the month of September, we have with us Mr. Amar
                          Kumar Pandey, Alumnus of Chemical Engineering
                          Department, NIT Durgapur (2022 Batch), currently
                          working as a Graduate Engineer Trainee (GET) at Larsen
                          and Toubro Energy- Hydrocarbon.
                        </ReadMore>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card members__box">
                    {/* <img className="card-img-top background__img" src={""} alt="Event poster" /> */}
                    <YouTube id="yAHx2XDa55s" />
                    <div className="card-body">
                      <h4 className="card-title">
                        Placement Talk with Mr. Sk Asfak Uddin, Vedanta
                        Resources Limited (Aug 27, 2022)
                      </h4>
                      <hr />
                      <p className="card-text">
                        <ReadMore>
                          This month, we host Mr. Sk Asfak Uddin, Alumnus of
                          Chemical Engineering Department, NIT Durgapur (2022
                          Batch), currently working as a Graduate Engineering
                          Trainee at Vedanta Resources Limited. Find topics
                          important to excel in interviews for entry level jobs
                          in core chemical engineering companies in the link
                          below:
                        </ReadMore>
                        <a
                          className="btn"
                          href="https://drive.google.com/file/d/1bQzThcxIP0M5ktCAqQ6SEXp39RyBc41_/view"
                        >
                          Click Here
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card members__box">
                    <YouTube id="6ruiD65jhcI" />
                    <div className="card-body">
                      <h4 className="card-title">
                        Miss Piyanjana Ghosh, currently placed at Hindustan
                        Unilever Limited (Jul 13, 2022)
                      </h4>
                      <hr />
                      <p className="card-text">
                        <ReadMore>
                          Chemical Engineering Students' Society (ChESS), NIT
                          Durgapur is back with its third episode of "A Chat
                          with ChESS: Placement Talk Sessions" This month, we
                          host Miss Piyanjana Ghosh, Alumnus of Chemical
                          Engineering Department, NIT Durgapur (2022 Batch), who
                          has secured placement opportunities at both Hindustan
                          Unilever Limited (as a Supply Chain Trainee) and at
                          Quantiphi (as a Business Analyst).
                        </ReadMore>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card members__box">
                    <YouTube id="xZSTUSNa5Rg" />
                    <div className="card-body">
                      <h4 className="card-title">
                        Mr. Debjit Goswami, currently placed at Deloitte USI
                        (Jun 21, 2022){" "}
                      </h4>
                      <hr />
                      <p className="card-text">
                        <ReadMore>
                          Chemical Engineering Students' Society (ChESS), NIT
                          Durgapur is back with its second episode of "A Chat
                          with ChESS: Placement Talk Sessions" This month, we
                          host Mr. Debjit Goswami, Alumnus of Chemical
                          Engineering Department, NIT Durgapur (2021 Batch),
                          currently working as a Technology Analyst at Deloitte
                          USI.
                        </ReadMore>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-12 col-lg-12">
                  <div className="card members__box">
                    <YouTube id="lnBL55afl7g" />
                    <div className="card-body">
                      <h4 className="card-title">
                        Mr Akhil Boyina, currently placed at Linde India (May
                        14, 2022)
                      </h4>
                      <hr />
                      <p className="card-text">
                        <ReadMore>
                          ChESS goes into a one-on-one interaction with the
                          distinguished Alumni of NIT Durgapur. The major
                          objective is to ask the concerned Alumnus pertinent
                          questions related to Placement Preparation Tips and
                          overall experience during the Placement Procedure. In
                          the first episode, we have ChESS hosting Mr. Akhil
                          Boyina, Batch of 2021, Department of Chemical
                          Engineering, NIT Durgapur who was placed at Linde in
                          the Campus Placement Session of 2020-21.
                        </ReadMore>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Achatwithchess;
